import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { RecursiveDescVisitor, Utils } from '@logio/common-be-fe';
export var CollectLookups =
/*#__PURE__*/
function (_RecursiveDescVisitor) {
  _inherits(CollectLookups, _RecursiveDescVisitor);

  function CollectLookups() {
    _classCallCheck(this, CollectLookups);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollectLookups).call(this, new Set()));
  }

  _createClass(CollectLookups, [{
    key: "visitProp",
    value: function visitProp(propDesc) {
      var ret = _get(_getPrototypeOf(CollectLookups.prototype), "visitProp", this).call(this, propDesc);

      if (Utils.isString(propDesc.description.lookup)) {
        ret.add(propDesc.description);
      }

      return ret;
    }
  }]);

  return CollectLookups;
}(RecursiveDescVisitor);